'use client';

import { useEffect, useState } from 'react';
import { getCustomizationData, subscribeToCustomizationData } from 'helpers/utils/customizationStorage';

const readAlbumTitle = (): string | undefined => {
  const { title } = getCustomizationData<{ title?: string }>();
  const trimmedTitle = typeof title === 'string' ? title.trim() : '';
  return trimmedTitle.length > 0 ? trimmedTitle : undefined;
};

/**
 * Title of the album the photos were picked from (e.g. a Google Photos album). Session storage
 * isn't reactive, so it's read in an effect and refreshed on every customization write.
 */
export const useAlbumTitle = (): string | undefined => {
  const [albumTitle, setAlbumTitle] = useState<string | undefined>(undefined);

  useEffect(() => {
    const refresh = () => setAlbumTitle(readAlbumTitle());
    refresh();
    return subscribeToCustomizationData(refresh);
  }, []);

  return albumTitle;
};
